export interface Version {
  versionNumber: string;
  buildNumber: string;
}

export const version: Version = {
  versionNumber: '2.4.664',
  buildNumber: 'fb4e52949b'
};
